import type * as z from 'zod/mini'

export class ErroApi extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message)
    this.name = 'ErroApi'
  }
}

/**
 * O endereço da API. Uma tela daqui reaproveitada noutro painel troca o endereço uma vez, ao montar; a tela não muda.
 * Hoje, o construtor da vitrine no CRM, para a vitrine federada (docs/43). `publico` é a origem das páginas públicas
 * que a tela mostra (a prévia, a capa).
 */
let endereco = (caminho: string) => `/api${caminho}`
let publico = ''
export const enderecoDaApi = (caminho: string) => endereco(caminho)
export const basePublica = () => publico
export function definirEnderecos(d: { api: (caminho: string) => string; publico: string }) {
  endereco = d.api
  publico = d.publico
}

async function tratar(r: Response) {
  if (r.status === 204) return null
  const corpo: unknown = await r.json().catch(() => null)
  if (!r.ok) {
    const erro = corpo && typeof corpo === 'object' && 'erro' in corpo ? String(corpo.erro) : r.statusText
    throw new ErroApi(r.status, erro)
  }
  return corpo
}

/** GET na API da instância, com a resposta validada pelo contrato. */
export async function obter<T extends z.ZodMiniType>(
  caminho: string,
  esquema: T,
  sinal?: AbortSignal,
): Promise<z.infer<T>> {
  const r = await fetch(enderecoDaApi(caminho), { headers: { Accept: 'application/json' }, signal: sinal ?? null })
  return esquema.parse(await tratar(r))
}

/** Escrita (POST, PUT, PATCH, DELETE) em JSON; com `esquema`, a resposta é validada. */
export async function enviar<T extends z.ZodMiniType>(
  metodo: 'POST' | 'PUT' | 'PATCH' | 'DELETE',
  caminho: string,
  corpo?: unknown,
  esquema?: T,
): Promise<z.infer<T>> {
  const r = await fetch(enderecoDaApi(caminho), {
    method: metodo,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(corpo ?? {}),
  })
  const dados = await tratar(r)
  return (esquema ? esquema.parse(dados) : dados) as z.infer<T>
}

/** Mensagem legível de qualquer erro, para toast ou aviso. */
export const mensagem = (e: unknown) => (e instanceof Error ? e.message : 'algo deu errado; tente de novo')
